import React, { useEffect, useState } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { useForm } from "../../context/FormContext";
import { CONTACT, IMAGES } from "../../config";

const LINKS = [
  { label: "Home", id: "home" },
  { label: "The Space", id: "gallery" },
  { label: "Ways to Use", id: "ways" },
  { label: "Events", id: "events" },
  { label: "Pricing", id: "pricing" },
  { label: "FAQ", id: "faq" },
];

export function Nav() {
  const { requestAvailability, scrollToId } = useForm();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-cream/90 backdrop-blur-md shadow-[0_3px_0_#74134322] py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-[1320px] mx-auto px-5 md:px-8 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => go("home")} className="flex items-center">
          <img src={IMAGES.logo} alt="DMediaClub logo" className="h-9 w-auto" />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="font-serif text-[0.95rem] text-berry hover:text-berry-deep hover:-translate-y-0.5 transition-all"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-request-btn"
            onClick={() => requestAvailability()}
            className="btn hidden sm:inline-flex items-center gap-2 bg-butter text-charcoal border-2 border-charcoal px-5 py-2.5 text-sm shadow-[3px_3px_0_#2A1020]"
          >
            <Sparkles size={15} strokeWidth={2} /> Inquire About a Booking
          </button>
          <button
            data-testid="nav-menu-toggle"
            className="lg:hidden p-2 text-berry"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X strokeWidth={2} /> : <Menu strokeWidth={2} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-cream border-t-2 border-berry/20 px-5 py-6" data-testid="mobile-menu">
          <div className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <button key={l.id} onClick={() => go(l.id)} className="text-left text-xl font-serif text-berry" data-testid={`mobile-nav-${l.id}`}>
                {l.label}
              </button>
            ))}
            <button
              onClick={() => { setOpen(false); requestAvailability(); }}
              data-testid="mobile-menu-request-btn"
              className="btn mt-2 bg-butter text-charcoal border-2 border-charcoal px-6 py-3 shadow-[3px_3px_0_#2A1020]"
            >
              Inquire About a Booking
            </button>
            <a href={`${CONTACT.whatsappBase}?text=${encodeURIComponent("Hi! I have a question about DMediaClub.")}`} target="_blank" rel="noreferrer" className="text-berry-deep font-serif">
              Ask a Question on WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
